<style lang="scss" scoped>
input,
textarea {
    background: #fff !important;
    font-size: 1rem;
    font-weight: 300;
    line-height: 19px;
    border-radius: 0px;
    height: 0;
    outline: none;
    border: none;
    border-bottom: 1px solid #cccccc;
    width: 100%;
    color: var(--dark);
    transition: border 0.15s ease-in-out;
    padding: 10px 0;
    display: block;
    margin: 0;

    &::placeholder {
        color: #6c757d;
    }

    &:focus {
        outline: none;
        box-shadow: none;
        border-color: var(--accent);
    }
}

input {
    height: 29px;
}
textarea {
    min-height: 72px;
}
label {
    width: 100%;
    color: var(--accent);
    font-weight: 600;
    font-size: 1rem;
    line-height: 19px;
    margin-bottom: 16px;
    &.text-status-error {
        color: var(--danger);

        & + input {
            border-bottom-color: var(--danger);

            &::placeholder {
                color: var(--danger);
            }
        }
    }
}

.v-select {
    ::v-deep .vs__dropdown-toggle {
        border-radius: 0px;
        border: none;
        padding: 0;
        border-bottom: 1px solid #cccccc;
    }

    ::v-deep input {
        padding: 0;
        margin: 0;
        line-height: 29px;
        height: 29px;

        &::placeholder {
            color: #6c757d;
        }
    }

    ::v-deep .vs__selected-options {
        padding: 0;
        margin: 0;
    }

    ::v-deep .vs__selected {
        padding: 0;
        margin: 0;
        line-height: 29px;
    }

    ::v-deep .vs__actions {
        padding-top: 0;
        transform: translateY(1px);
        cursor: pointer;

        button svg {
            transform: translateY(-3px);
        }
    }
    ::v-deep .vs__dropdown-option {
        font-size: 1rem;
        font-weight: 200;
        padding: 3px 8px;
        max-height: 155px;

        &.vs__dropdown-option--highlight {
            background: var(--accent);
            color: #fff;
        }

        &:hover {
            background: var(--accent);
            color: #fff;
        }
        &.selected {
            background: var(--accent);
            color: #fff;
        }
    }
}
</style>

<template>
    <ValidationProvider
        ref="provider"
        :vid="name || label.toLowerCase()"
        :name="label"
        :rules="rules"
        :bails="false"
        v-slot="{ classes, errors }"
        tag="div"
        class="form-group d-flex flex-column"
    >
        <label
            v-if="label.length > 0 && !errors[0]"
            :for="`id_${name || label.toLowerCase()}`"
            :class="classes"
            class="text-text-light small"
            >{{ label }}</label
        >
        <label v-if="errors[0]" class="text-status-error small">{{
            errors[0]
        }}</label>
        <textarea
            v-if="type === 'textarea'"
            v-model="localValue"
            v-on="{ ...$listeners, input: update }"
            class="form-control"
            :class="classes"
            :id="`id_${name || label.toLowerCase()}`"
            :aria-describedby="`description_${name || label.toLowerCase()}`"
            :placeholder="placeholder || `${label}...`"
            cols="3"
        ></textarea>
        <flat-pickr
            v-else-if="type === 'date'"
            :allowInput="true"
            v-on="{ ...$listeners, input: update }"
            :class="classes"
            :id="`id_${name || label.toLowerCase()}`"
            :aria-describedby="`description_${name || label.toLowerCase()}`"
            :placeholder="placeholder || `${label}...`"
            v-model="localValue"
            :config="config"
            class="form-control"
            name="date"
        ></flat-pickr>
        <v-select
            v-else-if="type === 'select'"
            :options="options"
            v-model="localValue"
            v-on="{ ...$listeners, input: update }"
            label="post_title"
            :class="classes"
            :id="`id_${name || label.toLowerCase()}`"
            :aria-describedby="`description_${name || label.toLowerCase()}`"
            :placeholder="placeholder || `${label}...`"
        >
        </v-select>
        <input
            v-else
            :type="type"
            v-model="localValue"
            v-on="{ ...$listeners, input: update }"
            class="form-control"
            :class="classes"
            :id="`id_${name || label.toLowerCase()}`"
            :aria-describedby="`description_${name || label.toLowerCase()}`"
            :placeholder="placeholder || `${label}...`"
        />
        <small
            v-if="description.length > 0"
            :id="`description_${name || label.toLowerCase()}`"
            class="form-text text-text-light"
            >{{ description }}</small
        >
    </ValidationProvider>
</template>

<script>
import HasInput from "../mixins/has-input";
import { ValidationProvider, validate } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: "components.forms.el_input",

    mixins: [HasInput],

    components: { ValidationProvider, flatPickr, vSelect },

    props: {
        type: {
            type: String,
            default: "text",
            validator: val => {
                return !![
                    "text",
                    "email",
                    "select",
                    "password",
                    "textarea",
                    "date",
                    "number"
                ].includes(val);
            }
        },
        options: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            config: {
                locale: Dutch,
                mode: "multiple",
                minDate: new Date(),
                dateFormat: "D j F Y"
                /*onClose: this.validateDate,
                onValueUpdate: this.validateDate*/
            }
        };
    },

    mounted() {
        if (this.type === "textarea") {
            // auto resize textarea
            var tx = document.getElementsByTagName("textarea");
            for (var i = 0; i < tx.length; i++) {
                tx[i].setAttribute(
                    "style",
                    "height:" + tx[i].scrollHeight + "px;overflow-y:hidden;"
                );
                tx[i].addEventListener("input", OnInput, false);
            }

            function OnInput() {
                this.style.height = "auto";
                this.style.height = this.scrollHeight + "px";
            }
        }
    },

    methods: {
        /*validateDate(selectedDates, dateStr, instance) {
            validate(dateStr, 'required|min:3').then(result => {
                if (result.valid) {
                    console.log(this.$refs.provider);
                } else {
                    console.log(this.$refs.provider);
                }
            });
        }*/
    }
};
</script>
